import { BsKanban, BsCreditCard2Front, BsTrashFill, BsCloudDownload } from "react-icons/bs";

export const VIEWS_MODE = {
  details: {
    icon: <BsCreditCard2Front className='mr-1' />,
    title: 'Détails',
  },
  scenari: {
    icon: <BsKanban className='mr-1' />,
    title: 'Scénarios',
  },
  exports: {
    icon: <BsCloudDownload className='mr-1' />,
    title: 'Exportation',
  },
  deletion: {
    icon: <BsTrashFill className='mr-1' />,
    title: 'Suppression',
  }
} as any
